import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  UserMailChangeSendRequestBody,
  UserMailChangeSendResponse,
} from "./types";

export class UserMailChangeSendAPI extends BaseAPI<
  UserMailChangeSendRequestBody,
  UserMailChangeSendResponse
> {
  protected route = ApiRoutes.auth.mail_change_send;
  protected method = RequestMethod.POST;
}
